//Componentes generales
import React, { useContext, useState } from 'react';
import UserInfo from '../../components/UserInfo/UserInfo';
import { Modal } from 'react-bootstrap';

//Estilos
import './Navbar.css';

//Contexto para recuperar usuario que se esta utilizando
import authContext from '../../context/authentication/authContex';

//Imagenes
import logoXertux from '../../images/MANTENIMIENTO.png';

// Iconos
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBell,
  faGlobe,
  faIdCardClip,
  faQuestionCircle
} from "@fortawesome/free-solid-svg-icons";
import { NAVBARS, TITLES, ICONS1 } from '../../constants/colors';
import { NavLink } from 'react-router-dom';
import Routes_gral from '../../utils/Routes_gral';

/* 
  Componente encargado del encabezado general de la pagina.
    Donde section es el titulo de la sección (Ruta nav) en que esta posicionado el usuario.
*/
const StyledNavbar_top = ({ section }) => {

  //Context de Autenticacion
  const aContext = useContext(authContext);
  const { usuario: user, showTuto, notShowTuto, checkIfSocio, checkIfCanchero, checkIfGestorReservas, checkIfRevisorReservas } = aContext;

  //State que determina si muestra o no el dialog de información del usuario.
  const [showUserInfo, setShowUserInfo] = useState(false);

  //Chequea si esta visible el dialog de información de usuario
  const checkEstadoVisibilidad = () => {
    showUserInfo ? setShowUserInfo(false) : setShowUserInfo(true);
  }

  return (
    <div className='topbar' style={{backgroundColor: NAVBARS}}>
      <div className='container-top-xx'>
        <img src={user.tenantId == 'CNMP' ? './nuevoLogoXertux.png' : './MANTENIMIENTO.png'} className='container-left-top-img-xx' alt='Logo-Top-Nav' />
        <h2 className='label-screen-h2-xx' style={{color: TITLES}}>{section}</h2>
        {user.tenantId == 'CNMP' && <img src={'./cnmpsinfondoCortado.png'} className='container-right-top-img-xx' alt='Logo-Top-Nav' />}
        {!checkIfSocio() && !checkIfCanchero() && !checkIfGestorReservas() && !checkIfRevisorReservas() &&
          <NavLink className={`${showTuto ? 'tutorial' : ''} globalSettings` } to={Routes_gral.globalSettings}>
            <FontAwesomeIcon icon={faGlobe} />
          </NavLink>
        }
        {!checkIfRevisorReservas() &&
          <NavLink className={`${showTuto ? 'tutorial' : ''} helpNavLinkContainer` } to={showTuto ? '#' : Routes_gral.ayuda}>
            <FontAwesomeIcon icon={faQuestionCircle} />
          </NavLink>
        }
        <div id='userInfo' className='navbar-item-icon-xx'>
          <FontAwesomeIcon style={{color: ICONS1, cursor: showTuto ? 'default' : 'pointer'}} icon={faIdCardClip} onClick={showTuto ? null : checkEstadoVisibilidad} />
        </div>
        {!checkIfRevisorReservas() &&
          <NavLink className={`${showTuto ? 'tutorial' : ''} notificacionesNavLinkContainer navbar-item-icon-xx`} to={showTuto ? '#' : Routes_gral.notificaciones}>
            <FontAwesomeIcon style={{color: ICONS1}} icon={faBell} />
          </NavLink>
        }
      </div>
      <Modal show={showUserInfo} onHide={checkEstadoVisibilidad} centered backdrop="static" style={{ zIndex: 9999 }} backdropClassName="modal-backdrop-high-z">
        <Modal.Body style={{ padding: 0, position: 'relative' }}>
          <button className="minimizarBtn" onClick={checkEstadoVisibilidad} style={{ position: 'absolute', top: 5, right: 5, zIndex: 1 }}>X</button>
          <UserInfo user={user} verCerrarSesion={true} mode={checkEstadoVisibilidad} />
        </Modal.Body>
      </Modal>
    </div>
  );
};
export default StyledNavbar_top;